﻿export class response_login_agency {
    public code: string | null = null;
    public name: string | null = null;
    public address_1: string | null = null;
    public address_2: string | null = null;
    public email: string | null = null;
    public post_code: string | null = null;
    public telephone: string | null = null;
    public band_id: number | null = null;
    public band_app_id: string | null = null;

}